import { WrapperService } from "../wrapper.service";
import { authHeader } from "../../_redux/_helpers/auth-header";

export class UserApiService {
  public apiService: WrapperService = new WrapperService();
  private requestTimeout = 0; //no timeout;
  private responseEncoding = "utf8";
  private baseURL = process.env.REACT_APP_API_PORT;

  public getUser(userId: string) {
    const apiParam = {
      name: "user",
      method: "GET",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: {},
      suffixURL: `/${userId}`,
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }

  public getUsers() {
    const apiParam = {
      name: "user",
      method: "GET",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: {},
      suffixURL: "/users",
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }

  public login(data: any) {
    const apiParam = {
      name: "user",
      method: "POST",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader,
      },
      body: data,
      suffixURL: "/login",
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }

  public register(data: any) {
    const apiParam = {
      name: "user",
      method: "POST",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader,
      },
      body: data,
      suffixURL: "/register",
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }
  public async deleteUser(id) {
    const apiParam = {
      name: "user",
      method: "DELETE",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: { id },
      suffixURL: `/delete`,
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }

  public editUser(body: any) {
    const apiParam = {
      name: "user",
      method: "PATCH",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: body,
      suffixURL: `/update`,
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }

  public resetPassword(body: any) {
    const apiParam = {
      name: "auth",
      method: "POST",
      params: {},
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: body,
      suffixURL: `/recover`,
      baseURL: this.baseURL,
      timeout: this.requestTimeout,
      withCredentials: true,
      responseType: "json",
      responseEncoding: this.responseEncoding,
    };
    return this.apiService.httpCall(apiParam, false);
  }
}
